import type {GratificationSettings} from "@/components/settings/scripts/Gratification";
import {ref} from "vue";
import {defaultFetch, httpMethod} from "@/scripts/Common/api";
import {getToken} from "@/scripts/Common";


const gratificationSettings = ref<GratificationSettings>({
  enabled: true,
  maximumAmountPerCharge: 60,
  maximumAnnualCount: 3
});

const responseError = ref<any>();

const loadGratificationSettings = async () => {
  const {
    error,
    response,
  } = await defaultFetch({
    apiName: 'gratificationConfiguration',
    bearer: getToken(),
    options: {
      method: httpMethod.GET,
    }
  });

  gratificationSettings.value = response;
  responseError.value = error;
}

const useGratificationSettings = () => {
  loadGratificationSettings();

  return {
    gratificationSettings,
    error: responseError
  }
}

export {
  useGratificationSettings
}
